'use client';

import { ReactNode } from 'react';
import ConsentPersonalInformationV1 from './consentPersonalInformation/v1';
import ConsentReceivePromotionalV1 from './consentReceivePromotional/v1';
import ConsentPersonalInformationMarketV1 from './consentPersonalInformationMarket/v1';

export const ConsentTypes = {
  consent_19_year_old: 'consent_19_year_old',
  consent_terms_service: 'consent_terms_service',
  consent_personal_information: 'consent_personal_information',
  consent_personal_information_market: 'consent_personal_information_market',
  consent_receive_promotional: 'consent_receive_promotional'
} as const;

export type ConsentType = (typeof ConsentTypes)[keyof typeof ConsentTypes];

export type ConsentConfigType = {
  key: string;
  required: boolean;
  parentConsent?: ConsentType;
  childConsent?: ConsentType;
  config: {
    version: string;
    content: string | ReactNode;
  }[];
};

export const DefaultConsentVersion: {
  [key in ConsentType]: string;
} = {
  consent_19_year_old: 'c1-1',
  consent_personal_information: 'c2-1',
  consent_personal_information_market: 'c3-1',
  consent_receive_promotional: 'c4-1',
  consent_terms_service: 'c5-1'
};

export const ConsentConfigs: { [key in ConsentType]: ConsentConfigType } = {
  consent_19_year_old: {
    key: 'consent_19_year_old',
    required: true,
    config: [
      {
        version: 'c1-1',
        content: <div />
      }
    ]
  },
  consent_terms_service: {
    key: 'consent_terms_service',
    required: true,
    config: [
      {
        version: 'c5-1',
        content: <div />
      }
    ]
  },
  consent_personal_information: {
    key: 'consent_personal_information',
    required: false,
    config: [
      {
        version: 'c2-1',
        content: <ConsentPersonalInformationV1 />
      }
    ]
  },
  consent_personal_information_market: {
    key: 'consent_personal_information_market',
    required: false,
    childConsent: 'consent_receive_promotional',
    config: [
      {
        version: 'c3-1',
        content: <ConsentPersonalInformationMarketV1 />
      }
    ]
  },
  consent_receive_promotional: {
    key: 'consent_receive_promotional',
    required: false,
    parentConsent: 'consent_personal_information_market',
    config: [
      {
        version: 'c4-1',
        content: <ConsentReceivePromotionalV1 />
      }
    ]
  }
};
